import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];

export default function Science({ onOpenSources }) {
  const { t } = useI18n();
  return (
    <section
      id="literature"
      className="section border-t hair"
      data-testid="science-section"
    >
      <div className="container-edge">
        <SectionHead
          kana={t.sections.literature.kana}
          roman={t.sections.literature.roman}
          right={<span className="mono" style={{ color: "var(--faded)" }}>fig. 02</span>}
        />

        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10">
          <motion.div
            className="col-span-12 md:col-span-5"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease }}
          >
            <h2 className="display text-[36px] sm:text-[44px] md:text-[60px]" data-testid="science-heading">
              {t.literature.heading}
            </h2>
            <p className="body-text mt-6" style={{ maxWidth: "30ch" }}>
              {t.literature.sub}
            </p>
            <button
              type="button"
              onClick={onOpenSources}
              className="mono-md under-link mt-10 md:mt-14"
              style={{ color: "var(--ink)" }}
              data-testid="science-sources-link"
            >
              {t.literature.seeAll}  →
            </button>
          </motion.div>

          <div className="col-span-12 md:col-span-7 md:col-start-6 border-t hair">
            {t.literature.items.map((p, i) => (
              <motion.div
                key={i}
                className="border-b hair py-8 md:py-10 grid grid-cols-12 gap-4"
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease, delay: i * 0.06 }}
                data-testid={`science-citation-${i + 1}`}
              >
                <span className="col-span-2 mono pt-1" style={{ color: "var(--faded)" }}>
                  {p.n}
                </span>
                <div className="col-span-10">
                  <p className="text-[16px] md:text-[18px] leading-[1.45]" style={{ fontWeight: 300 }}>
                    {p.text}
                  </p>
                  <p className="mono mt-3" style={{ color: "var(--faded)" }}>
                    {p.cite}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
